import { handleReloadEvent } from './reloadEvent';
import { handleContextExampleEvent } from './contextExampleEvent';
import { handleAdmissionPaymentConfirmedEvent } from './admissionPaymentConfirmedEvent';

const eventHandlers = {
  reload: handleReloadEvent,
  context_example: handleContextExampleEvent,
  admission_payment_confirmed: handleAdmissionPaymentConfirmedEvent,
};

function extractEventName(notificationPayload) {
  if (typeof notificationPayload?.event === 'string') {
    return notificationPayload.event.toLowerCase();
  }

  if (typeof notificationPayload?.payload?.event === 'string') {
    return notificationPayload.payload.event.toLowerCase();
  }

  return null;
}

export function dispatchSseEvent(notificationPayload) {
  const eventName = extractEventName(notificationPayload);
  if (!eventName) {
    return false;
  }

  const eventHandler = eventHandlers[eventName];
  if (!eventHandler) {
    return false;
  }

  eventHandler(notificationPayload);
  return true;
}
